import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store'
import './plugins/element';
import './plugins/registerComponent';
// import './iView-ui';

import {
    loadStyle
} from './utils/util'
import './utils/directives';
import * as urls from '@/config/env';
import downLoadFile from '@/utils/down'
import wangEditor from '@/utils/wangEditor'
import {
    iconfontUrl,
    iconfontVersion
} from '@/config/env';
import elDisableRepeat from './utils/disableRepeatClick/index'
import previewCard from "@/components/highSearch/previewCard.vue";


import G2 from '@antv/g2';
import {isEmpty} from '@/utils/util'

Vue.use(G2)

window.messageImg  = wangEditor.messageImg
window.messageImg3  = wangEditor.messageImg3
window.goMessage = wangEditor.goMessage
window.goServe = wangEditor.goServe
window.goOfficialAccounts = wangEditor.goOfficialAccounts
Vue.use(elDisableRepeat)
Vue.use(wangEditor)
Vue.component('previewCard', previewCard)
Vue.prototype.errorImgRectangle = 'this.src="img/rectangle.png"'
Vue.prototype.errorHeadImg = 'this.src="img/ic_avatar.png"'

// 计算表格高度
Vue.prototype.getMaxHeight = function(value) {
    // console.log(window.innerHeight, 'ssss')
    // console.log(document.body.clientHeight, 'ssssssssssss')
    if (top != self) {
        return (window.innerHeight - value + 41)
    } else {
        return (document.body.clientHeight - value + 41)
    }
  }

// 弹窗拖拽
import elDragDialog from './utils/el-dragDialog/index'
Vue.use(elDragDialog)

// 加载相关url地址
Object.keys(urls).forEach(key => {
  Vue.prototype[key] = urls[key];
})

// 动态加载阿里云字体库
iconfontVersion.forEach(ele => {
    loadStyle(iconfontUrl.replace('$key', ele));
})

Vue.config.productionTip = false
Vue.prototype.$downLoadFile = downLoadFile
Vue.prototype.isEmpty = isEmpty

new Vue({
	router,
    store,
	render: h => h(App)
}).$mount('#app')
